import React from 'react';
// import CircularProgress from '@material-ui/core/CircularProgress';
import LinearProgress from '@material-ui/core/LinearProgress';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useSelector } from 'react-redux';
import jsonApiDuck from '../../redux/modules/jsonApiDuck';
import {
  isSpinnerDisabledV2,
  isBusyV2,
} from '../../redux/modules/jsonApiDuckV2';
import { grey } from '@material-ui/core/colors';

export default () => (
  <div style={{ minHeight: 500, margin: 'auto', maxWidth: 800 }}>
    <LinearProgress />
  </div>
);

const circularLoadingStyle = {
  background: 'rgba(0, 0, 0, 0.2)',
  height: '100vh',
  width: '100%',
  position: 'fixed',
  left: 0,
  top: 0,
  zIndex: 2000,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

export const CircularLoading = () => (
  <div style={circularLoadingStyle}>
    <CircularProgress size={200} thickness={5} style={{ color: grey[700] }} />
  </div>
);

export const CircularLoadingJsonapi = () => {
  const isBusy = useSelector(jsonApiDuck.selectors.isBusy);
  return isBusy && <CircularLoading />;
};

export const CircularLoadingJsonapiV2 = () => {
  const isSpinnerDisabled = useSelector(isSpinnerDisabledV2);
  const isBusy = useSelector(isBusyV2);
  return isBusy && !isSpinnerDisabled && <CircularLoading />;
};
